<div class="dropright">
  <button
    mat-raised-button
    data-toggle="dropdown"
    class="btn btn-sm btn-clean dropdown-toggle px-4"
  >
    {{ 'GLOBAL.FILTER' | translate }}
    <i class="ki ki-arrow-down icon-sm text-primary ml-2"></i>
  </button>

  <div
    class="dropdown-menu p-5 dropdown-menu-right dropdown-menu-anim-up dropdown-menu-lg"
    (click)="$event.stopPropagation()"
  >
    <div class="row">
      <button
        mat-button
        color="{{ withFollowup ? 'primary' : '' }}"
        #withFollowupBtn
        (click)="filterWF()"
      >
        With Follow-up
      </button>
    </div>
    <div class="d-flex justify-content-between mb-5">
      <mat-form-field appearance="outline" style="width: 150px !important" class="p-0">
        <mat-label>From Date</mat-label>
        <input
          matInput
          [matDatepicker]="fromPicker"
          placeholder="MM/DD/YYYY"
          [formControl]="fromDate"
          (dateChange)="dispatchEvent()"
          ktDateMask
          maxlength="10"
          [matDatepickerFilter]="startFilter.bind(parent)"
        />
        <mat-datepicker-toggle matSuffix [for]="fromPicker"></mat-datepicker-toggle>
        <mat-datepicker #fromPicker></mat-datepicker>
      </mat-form-field>
      <mat-form-field appearance="outline" style="width: 150px !important" class="p-0">
        <mat-label>To Date</mat-label>
        <input
          matInput
          [matDatepicker]="toPicker"
          placeholder="MM/DD/YYYY"
          [formControl]="toDate"
          (dateChange)="dispatchEvent()"
          ktDateMask
          maxlength="10"
          [matDatepickerFilter]="toFilter.bind(parent)"
        />
        <mat-datepicker-toggle matSuffix [for]="toPicker"></mat-datepicker-toggle>
        <mat-datepicker #toPicker></mat-datepicker>
      </mat-form-field>
    </div>
    <mat-form-field appearance="outline" class="mb-5">
      <mat-label>Status</mat-label>
      <mat-select [formControl]="status" (selectionChange)="filterChanged()">
        <mat-option value="">All</mat-option>
        <mat-option *ngFor="let status of statusList | async" [value]="status.label">{{
          status.label
        }}</mat-option>
      </mat-select>
    </mat-form-field>
    <mat-form-field appearance="outline" class="mb-5">
      <mat-label>Category</mat-label>
      <mat-select [formControl]="category" (selectionChange)="filterChanged()">
        <mat-option>None</mat-option>
        <mat-option value="true">without category</mat-option>
        <mat-option *ngFor="let cat of categoryList" [value]="cat.id">{{ cat.name }}</mat-option>
      </mat-select>
    </mat-form-field>
    <div class="mb-5">
      <kt-general-autocomplete
        #officeAutocomplete
        [appearance]="'outline'"
        [label]="'Office'"
        [dataPath]="'data'"
        [loadItemsFunction]="getOfficeAutocomplete"
        [optionFormatter]="formatOfficeOption"
        [valueFormatter]="formatOfficeOption"
        [change]="dispatchEvent.bind(this)"
        [control]="officeAutocomplete"
        [required]="false"
        [readOnly]="false"
      ></kt-general-autocomplete>
    </div>
    <div *ngFor="let filter of filtersArray">
      <kt-dynamic-filters
        [filters]="filter"
        (getMyFilters)="filterChanges($event)"
      ></kt-dynamic-filters>
    </div>
  </div>
</div>
